function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.3254 6.67502C17.3254 6.17797 16.9225 5.77502 16.4254 5.77502H5.17539C4.67834 5.77502 4.27539 6.17796 4.27539 6.67502V7.84112C4.27539 8.25848 4.57091 8.60834 4.94165 8.79999C5.88236 9.28625 6.52539 10.268 6.52539 11.4C6.52539 12.532 5.88236 13.5138 4.94165 14C4.57091 14.1917 4.27539 14.5416 4.27539 14.9589V16.125C4.27539 16.6221 4.67833 17.025 5.17539 17.025H16.4254C16.9225 17.025 17.3254 16.6221 17.3254 16.125V14.9589C17.3254 14.5416 17.0298 14.1917 16.6591 14C15.7184 13.5138 15.0754 12.532 15.0754 11.4C15.0754 10.268 15.7184 9.28625 16.6591 8.79999C17.0298 8.60834 17.3254 8.25848 17.3254 7.84112V6.67502Z",
    stroke: "#1B1B1B",
    style: {
      stroke: "#1B1B1B",
      stroke: "color(display-p3 0.1041 0.1041 0.1041)",
      strokeOpacity: 1
    },
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/Ticket.90b73959ff7b88a2bce8ee253ac93acd.svg";
export { ForwardRef as ReactComponent };